import { render, staticRenderFns } from "./InputSimpleCustomer.vue?vue&type=template&id=c183f0a2&scoped=true"
import script from "./InputSimpleCustomer.vue?vue&type=script&lang=ts"
export * from "./InputSimpleCustomer.vue?vue&type=script&lang=ts"
import style0 from "./InputSimpleCustomer.vue?vue&type=style&index=0&id=c183f0a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c183f0a2",
  null
  
)

export default component.exports